enum AuthSecurityLevel {
    L0 = 'L0',
    L1 = 'L1',
    L2 = 'L2',
    L3 = 'L3',
}

export default AuthSecurityLevel;